require('./sortArrows.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @constants
const KEY_UP= 'up';
const KEY_DOWN= 'down';

class SortArrows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabledKey: ''
        };
        this.handleArrowClick = this.handleArrowClick.bind(this);
    }

    handleArrowClick(key){
        const { onHandleSort, listId, sortKey } = this.props;
        this.setState({
            disabledKey: key
        });
        onHandleSort(sortKey, listId, key);
    }

    render() {
        
        const { disabledKey } = this.state;
        const upArrowClasses = classNames('sort-arrows__arrows-icon-button' , {
            'sort-arrows__arrows-icon-button--disabled': disabledKey === KEY_UP
        });
        const downArrowClasses = classNames('sort-arrows__arrows-icon-button' , {
            'sort-arrows__arrows-icon-button--disabled': disabledKey === KEY_DOWN
        });

        return (
            <div className="sort-arrows__arrows">
                <div
                    className={upArrowClasses}
                    modifier="link-ghost"
                    onClick={()=>{this.handleArrowClick(KEY_UP)}}
                >
                    <i className="icon-alza sort-arrows__arrows-icon"></i>
                </div>
                <div
                    className={downArrowClasses}
                    modifier="link-ghost"
                    onClick={()=>{this.handleArrowClick(KEY_DOWN)}}
                >
                    <i className="icon-baja sort-arrows__arrows-icon"></i>
                </div>
            </div>
        );
    }
}

SortArrows.propTypes = {
    listId: PropTypes.number.isRequired,
    onHandleSort: PropTypes.func.isRequired,
    sortKey: PropTypes.string.isRequired,    
};

module.exports = SortArrows;
